export default {
  name: 'uiexamples',
  components: {},
  props: [],
  data () {
    return {
      sample: {},
      typeOfManuscript: [
        { value: 0, text: 'Procedural GL' },
        { value: 1, text: 'Clinical GL' },
        { value: 2, text: 'Systematic review / Meta-Analysis' },
        { value: 3, text: 'Lorem ipsum' },
        { value: 4, text: 'Dolor matiser' },
      ],

      destinationOfManuscript: [
        { value: 0, text: 'EANM-only' },
        { value: 1, text: 'Joint with other society' },
      ],

      guidelineTypes: [
        { value: null, text: this.$t('message.Guideline.typeLabelChoose') },
        { value: 'BJ', text: this.$t('message.Guideline.BJ') },
        { value: 'CV', text: this.$t('message.Guideline.CV') },
        { value: 'DO', text: this.$t('message.Guideline.DO') },
        { value: 'DD', text: this.$t('message.Guideline.DD') },
        { value: 'ET', text: this.$t('message.Guideline.ET') },
        { value: 'II', text: this.$t('message.Guideline.II') },
        { value: 'NI', text: this.$t('message.Guideline.NI') },
        { value: 'OT', text: this.$t('message.Guideline.OT') },
        { value: 'PA', text: this.$t('message.Guideline.PA') },
        { value: 'PH', text: this.$t('message.Guideline.PH') },
        { value: 'RP', text: this.$t('message.Guideline.RP') },
        { value: 'RY', text: this.$t('message.Guideline.RY') },
        { value: 'TE', text: this.$t('message.Guideline.TE') },
        { value: 'TY', text: this.$t('message.Guideline.TY') },
        { value: 'MI', text: this.$t('message.Guideline.MI') },
      ],

      selected: ['foo', 'bar'],
      selected1: null,

      file: null,
      file2: null,

      placements: [
        'topright', 'top', 'topleft',
        'bottomright', 'bottom', 'bottomleft',
        'righttop', 'right', 'lefttop',
        'rightbottom', 'left', 'leftbottom'
      ],

      events: [
        {
            title  : 'event1',
            start  : (new Date()).toISOString(),
        },
        {
            title  : 'event2',
            start  : this.moment(),
            end    : this.moment().add(1, 'days')
        },
        {
            title  : 'event3',
            start  : this.moment().add(5, 'days'),
            allDay : this.moment().add(8, 'days'),
        },
      ],
      config: {
        weekends: true,
        defaultView: 'month',
        locale: 'de',
        drop(...args) {
          //handle drop logic in parent
        },
      },

      fields: {
        last_name: {
          label: 'Person last name',
          sortable: true
        },
        first_name: {
          label: 'Person first name',
          sortable: false
        },
        foo: {
          // This key overrides `foo`!
          key: 'age',
          label: 'Person age',
          sortable: true
        },
        city: {
          key: 'address.city'
        },
        'address.country': {
          label: 'Country'
        }
      },
      items: [
        { isActive: true, age: 40, first_name: 'Dickerson', last_name: 'Macdonald', address: { country: 'USA', city: 'New York' } },
        { isActive: false, age: 21, first_name: 'Larsen', last_name: 'Shaw', address: { country: 'Canada', city: 'Toronto' }},
        { isActive: false, age: 89, first_name: 'Geneva', last_name: 'Wilson', address: { country: 'Australia', city: 'Sydney' } },
        { isActive: true, age: 38, first_name: 'Jami', last_name: 'Carney', address: { country: 'England', city: 'London' } }
      ]
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
